import { Form, DatePicker, Row, Col, Input, Button } from "antd";
import TextArea from "antd/es/input/TextArea";
import React, { useEffect } from "react";
import { BiDollar } from "react-icons/bi";
import { BsCurrencyDollar } from "react-icons/bs";
import { TbMoodDollar } from "react-icons/tb";
import "./style.css";
const Index = ({ setActive }) => {
  const [form] = Form.useForm();

  const onSub = async (values) => {
    setActive(true);
    let res = await fetch(
      `${process.env.REACT_APP_BASE_URL}/api/security-deposit`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(values),
      }
    );
    const { pdfBase64 } = await res.json();
    const byteCharacters = atob(pdfBase64);
    const byteNumbers = new Array(byteCharacters.length)
      .fill(null)
      .map((_, i) => byteCharacters.charCodeAt(i));
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);
    console.log("url", url);
    // Create a link element to download the PDF
    const a = document.createElement("a");
    a.href = url;
    a.download = "Security Deposit"; // Set the desired file name
    document.body.appendChild(a);
    a.click();

    // Clean up
    a.remove();
    window.URL.revokeObjectURL(url);
    setActive(false);
  };

  return (
    <div className="main">
      <Form form={form} onFinish={onSub}>
        <Row gutter={16} justify={"space-evenly"}>
          <Col md={12}>
            <label>Tenant Name</label>
            <Form.Item
              name="tenant_name"
              rules={[{ required: true, message: "required" }]}
            >
              <Input placeholder="Tenant Name" />
            </Form.Item>
          </Col>
          <Col md={12}>
            <label>Apartment #</label>
            <Form.Item
              name="appartment_no"
              rules={[{ required: true, message: "required" }]}
            >
              <Input placeholder="Apartment No" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16} justify={"space-evenly"}>
          <Col md={12}>
            <label>Landlord</label>
            <Form.Item
              name="landlord"
              rules={[{ required: true, message: "required" }]}
            >
              <Input placeholder="Landlord" />
            </Form.Item>
          </Col>
          <Col md={12}>
            <label>Address</label>
            <Form.Item
              name="address"
              rules={[{ required: true, message: "required" }]}
            >
              <TextArea
                rows={3}
                style={{ resize: "none" }}
                placeholder="Enter Address"
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16} justify={"space-evenly"}>
          <Col md={6}>
            <label>First Month’s Rent</label>
            <Form.Item
              name="first_month_rent"
              rules={[{ required: true, message: "required" }]}
            >
              <Input
                className="prefix-field"
                placeholder="First Month Rent"
                prefix={<BsCurrencyDollar />}
              />
            </Form.Item>
          </Col>
          <Col md={6}>
            <label>Last Month’s Rent</label>
            <Form.Item
              name="last_month_rent"
              rules={[{ required: true, message: "required" }]}
            >
              <Input
                className="prefix-field"
                placeholder="Last Month Rent"
                prefix={<BsCurrencyDollar />}
              />
            </Form.Item>
          </Col>
          <Col md={6}>
            <label>Security Deposit</label>
            <Form.Item
              name="security_deposit"
              rules={[{ required: true, message: "required" }]}
            >
              <Input
                className="prefix-field"
                placeholder="Security Deposit"
                prefix={<BsCurrencyDollar />}
              />
            </Form.Item>
          </Col>
          <Col md={6}>
            <label>Total Due at Signing</label>
            <Form.Item
              name="total_due_signing"
              rules={[{ required: true, message: "required" }]}
            >
              <Input
                className="prefix-field"
                placeholder="Total Due at Signing"
                prefix={<BsCurrencyDollar />}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16} justify={"start"}>
          <Col md={6}>
            <label>Check Number</label>
            <Form.Item name="check_number">
              <Input placeholder="Check #" />
            </Form.Item>
          </Col>
        </Row>
        <hr />
        <Row gutter={16} justify={"space-evenly"}>
          <Col md={12}>
            <label>Name of Bank</label>
            <Form.Item name="bank_name">
              <Input placeholder="Bank Name" />
            </Form.Item>
          </Col>
          <Col md={12}>
            <label>Account #</label>
            <Form.Item name="account">
              <Input placeholder="Account #" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16} justify={"space-evenly"}>
          <Col md={12}>
            <label>Address of Bank</label>
            <Form.Item name="bank_address">
              <Input placeholder="Bank Address" />
            </Form.Item>
          </Col>
          <Col md={12}>
            <label>Date Received</label>
            <Form.Item name="date_received">
              <DatePicker />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item>
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default Index;
